import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    formControl: {
      margin: theme.spacing(1),
      width: '80%',

      alignItems: 'center',
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    chip: {
      margin: 2,
    },
    metricBoxChart: {
      padding: theme.spacing(2),
      height: '100%',
    },
    metricGridItems: {
      marginTop: theme.spacing(3),
    },
    metricGridItemsFull: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    fullView: {
      padding: '0 4vw',
    },
    paper: {
      color: theme.palette.text.secondary,
      display: 'flex',
      flexDirection: 'row',
      marginTop: theme.spacing(3),
      padding: theme.spacing(2),
      paddingBottom: theme.spacing(3),
      textAlign: 'center',
    },
    sides: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '4vh 5vw',
      width: '50%',
    },
    subtitle: {
      fontFamily: 'Montserrat',
      fontSize: '1.2em',
      fontWeight: 'bold',
      margin: '0 0 2vh',
      textAlign: 'left',
      textTransform: 'uppercase',
    },
    text: {
      fontSize: '1em',
      margin: '2vh 0',
      textAlign: 'left',
    },
    text2: {
      fontSize: '1em',
      margin: '2vh 0',
      textAlign: 'left',
    },
    save: {
      margin: theme.spacing(3, 0, 2),
    },
    button: {
      top: 'auto',
      bottom: 0,
      fontSize: '1.1em',
      fontWeight: 'bold',
      fontFamily: 'Montserrat',
      minHeight: '4vh',
      maxWidth: '70%',
    },
    list: {
      overflowX: 'hidden',
      overflowY: 'auto',
      margin: '20px 0',
      width: '100%',
    },
    listManangers: {
      maxHeight: '300px',
    },
    listChannels: {
      maxHeight: '380px',
    },
    supInput: {
      minWidth: '24vw',
    },
    switch: {
      justifyContent: 'left',
      marginLeft: 10,
    },
    tabs: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
  })
);
